import PropTypes from 'prop-types';

/**
 * MenuItem definition.
 */
export const MenuItemProps = {
  eventProps: PropTypes.shape({}),
  icon: PropTypes.string,
  isBeta: PropTypes.bool,
  itemAttributes: PropTypes.shape({}),
  links: PropTypes.array,
  newItem: PropTypes.bool,
  onClick: PropTypes.func,
  path: PropTypes.string,
  target: PropTypes.string,
  title: PropTypes.string.isRequired,
  tooltip: PropTypes.string,
  url: PropTypes.string,
};

MenuItemProps.links = PropTypes.arrayOf(PropTypes.shape(MenuItemProps));
